
import React, { useEffect, useRef } from "react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ChatMessage } from "@/components/ChatMessage";
import { WaitingIndicator } from "@/components/chat/WaitingIndicator";
import { Message, WaitingMessage, MessageCategory } from "@/types/chat";

interface ChatWidgetMessagesProps {
  messages: Message[];
  isLoading: boolean;
  scrollAreaRef: React.RefObject<HTMLDivElement>;
  waitingMessages: WaitingMessage[];
  isShowingWaitingMessages: boolean;
  waitingMessageCategory: MessageCategory;
}

export function ChatWidgetMessages({ 
  messages, 
  isLoading, 
  scrollAreaRef,
  waitingMessages,
  isShowingWaitingMessages,
  waitingMessageCategory
}: ChatWidgetMessagesProps) {
  
  // Ensure scrolling to bottom when messages change
  useEffect(() => {
    if (scrollAreaRef.current) {
      const scrollContainer = scrollAreaRef.current.querySelector('[data-radix-scroll-area-viewport]');
      if (scrollContainer) {
        scrollContainer.scrollTop = scrollContainer.scrollHeight;
      }
    }
  }, [messages, scrollAreaRef]);

  return (
    <ScrollArea className="flex-1 p-4" ref={scrollAreaRef}>
      <div className="flex flex-col space-y-4">
        {messages.map((message) => (
          <ChatMessage key={message.id} message={message} />
        ))}
        
        {isLoading && (
          <WaitingIndicator 
            waitingMessages={waitingMessages}
            isShowingWaitingMessages={true}
            category={waitingMessageCategory}
          />
        )}
      </div>
    </ScrollArea>
  );
}
